<div class="card">
    <div class="card-body">
      <div class="d-flex mb-3">
        <h4 class="card-title">Subscriptions</h4>
        <button type="button" class="btn btn-primary ms-auto" (click)="addNewModal()">
          Add New
        </button>
      </div>
      <!-- <p class="card-description">
        Basic form layout
      </p> -->
      <!-- <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover"></table> -->
      <ng-template #subscriptionActions let-data="adtData" let-emitter="captureEvents">
        <app-subscription-actions [data]="data" (emitter)="emitter($event)"></app-subscription-actions>
      </ng-template>
      <app-admin-new-subscription [modalid]="modalid" (newItemEvent)="changeData($event)"></app-admin-new-subscription>
      <app-admin-cancel-subscription [modalid]="modalid1" table="purchases" [id]="deleteid" (newItemEvent)="changeData($event)"></app-admin-cancel-subscription>
      
      <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table subscription-table"></table>
    </div>
</div>